"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Icons_1 = require("../../../Icons");
var Localization_1 = require("../../../Localization");
var Slider_styles_1 = require("./Slider.styles");
exports.default = React.forwardRef(function (_a, ref) {
    var OnZoomChange = _a.OnZoomChange;
    var handleSliderChange = function (e) {
        var scale = Number(e.target.value);
        OnZoomChange(scale);
    };
    return (React.createElement(Slider_styles_1.SliderWrapper, null,
        React.createElement(Slider_styles_1.IconWrapper, null,
            React.createElement(Icons_1.PictureIcon, { Height: "16px", Width: "16px" })),
        React.createElement(Slider_styles_1.Slider, { "aria-label": Localization_1.strings.UploadAvatar_Label_ZoomPhoto, max: "3", min: "0", onChange: handleSliderChange, ref: ref, step: "0.001", title: Localization_1.strings.UploadAvatar_Label_ZoomPhoto, type: "range" }),
        React.createElement(Slider_styles_1.IconWrapper, null,
            React.createElement(Icons_1.PictureIcon, { Height: "32px", Width: "32px" }))));
});
